
<template>
  <div class="main-content">
    <Container
      :title="t('route.application')"
      :hasLine="true"
    >
      <template #header>
        <SearchForm
          ref="searchFormRef"
          :formModel="searchFormModel"
          :formStruct="searchFormStruct"
          :submitButton="t('common.search')"
          :resetButton="t('common.reset')"
          @submit="submitSearch"
          @reset="resetForm"
        />
      </template>
      <template #main>
        <el-button
          v-if="this.$hasPermission(['ACTION_vcApplicationEdit'])"
          @click="handleCreate()"
          type="success"
        >
          {{ t('table.add') }}
        </el-button>
        <el-button
          v-if="selection.length > 0 && this.$hasPermission(['ACTION_vcApplicationEdit'])"
          @click="handleBathDelete()"
          type="danger"
        >
          {{ t('table.bathDelete') }}
        </el-button>
        <SimpleTable
          :isLoading="listLoading"
          :tableData="tableData"
          :columnStruct="columnStruct"
          :sort="sort"
          :order="order"
          @handleOrder="handleOrder"
          @handleSelection="handleSelection"
        >
          <template
            v-if="this.$hasPermission(['ACTION_vcApplicationEdit'])"
            #default="slotProps"
          >
            <el-button
              @click="handleEdit(slotProps.row)"
              type="primary"
              size="mini"
            >
              {{ t('common.edit') }}
            </el-button>
            <el-button
              @click="handleDelete(slotProps.row.id)"
              type="danger"
              size="mini"
            >
              {{ t('common.delete') }}
            </el-button>
          </template>
        </SimpleTable>
        <el-pagination
          :total="total"
          v-show="total > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          :current-page="page"
          :page-sizes="[5, 10, 20]"
          layout="total, sizes, prev, pager, next, jumper"
          style="text-align: right;"
        />
      </template>
    </Container>
    <el-dialog
      v-if="this.$hasPermission(['ACTION_vcApplicationEdit'])"
      :title="t(textMap[dialogStatus])"
      center
      v-model="dialogFormVisible"
      width="45%"
    >
      <NomalContainer>
        <CenterForm
          v-if="dialogStatus === 'create'"
          :formModel="createModel"
          :formStruct="createStruct"
          :formRules="applicationRole"
          @submit="createSubmit"
          @reset="createReset"
        />
        <CenterForm
          v-if="dialogStatus === 'update'"
          :formModel="updateModel"
          :formStruct="updateStruct"
          :formRules="applicationRole"
          @submit="updateNameSubmit"
          @reset="updateNameReset"
        >
          <template #default="">
            <UploadFormItem
              ref="updateUpload"
              prop="file"
              :data="uploadPackageModel"
              :label="t('application.packageAddress')"
              :fileName="packageAddress"
              :action="getUploadUri()"
              :headers="getUploadHeader()"
              @upload="handleUpload"
            />
          </template>
        </CenterForm>
      </NomalContainer>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { ElForm, ElMessage, ElMessageBox, ElLoading } from 'element-plus'
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import Container from '@/components/form/container/Container.vue'
import SearchForm from '@/components/form/search/SearchForm.vue'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import CenterForm from '@/components/form/common/CenterForm.vue'
import NomalContainer from '@/components/dfms-components/container/NomalContainer.vue'
import UploadFormItem from '@/components/form/common/UploadFormItem.vue'
import {
  ApplicationModel,
  ApplicationPageSearchModel,
  ApplicationSearchModel,
  ApplicationAddModel,
  ApplicationUpdateModel,
  IdsModel
} from '@/model/product/ApplicationModel'
import {
  pageSearchApplication,
  addApplication,
  updateApplication,
  removeApplication,
  batchRemoveApplication
} from '@/apis/product/application'
import { parseTime } from '@/utils'
import { createModel } from '@/utils/component'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useStore } from '@/store'
import networkConfig from '@/config/default/net.config'
import { Route } from '@/constant/route'

export default defineComponent({
  components: {
    Container,
    SearchForm,
    SimpleTable,
    CenterForm,
    UploadFormItem,
    NomalContainer
  },
  setup() {
    const { t } = useI18n()
    const searchFormRef = ref(ElForm)
    const updateUpload = ref()
    const router = useRouter()
    const searchStruct = [
      { prop: 'appName', label: t('application.appName'), placeholder: t('application.appNameP'), component: 'el-input', type: 'text', model: null },
      // { prop: 'appDescription', label: t('application.appDescription'), placeholder: t('application.appDescriptionP'), component: 'el-input', type: 'text', model: null },
      { prop: 'partnerNumber', label: t('application.partnerNumber'), placeholder: t('application.partnerNumberP'), component: 'el-input', type: 'text', model: null }
      // { prop: 'minVersion', label: t('application.minVersion'), placeholder: t('application.minVersionP'), component: 'el-input', type: 'text', model: null },
      // { prop: 'currentVersion', label: t('application.currentVersion'), placeholder: t('application.currentVersionP'), component: 'el-input', type: 'text', model: null },
      // { prop: 'packageAddress', label: t('application.packageAddress'), placeholder: t('application.packageAddressP'), component: 'el-input', type: 'text', model: null }
    ]

    const createStruct = [
      { prop: 'appName', label: t('application.appName'), placeholder: t('application.appNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'appDescription', label: t('application.appDescription'), placeholder: t('application.appDescriptionP'), component: 'el-input', type: 'text', model: null },
      // { prop: 'partnerNumber', label: t('application.partnerNumber'), placeholder: t('application.partnerNumberP'), component: 'el-input', type: 'text', model: null },
      { prop: 'minVersion', label: t('application.minVersion'), placeholder: t('application.minVersionP'), component: 'el-input', type: 'text', model: null }
      // { prop: 'currentVersion', label: t('application.currentVersion'), placeholder: t('application.currentVersionP'), component: 'el-input', type: 'text', model: null },
      // { prop: 'packageAddress', label: t('application.packageAddress'), placeholder: t('application.packageAddressP'), component: 'el-input', type: 'text', model: null }
    ]

    const updateStruct = [
      { prop: 'appName', label: t('application.appName'), placeholder: t('application.appNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'appDescription', label: t('application.appDescription'), placeholder: t('application.appDescriptionP'), component: 'el-input', type: 'text', model: null },
      // { prop: 'partnerNumber', label: t('application.partnerNumber'), placeholder: t('application.partnerNumberP'), component: 'el-input', type: 'text', model: null },
      { prop: 'minVersion', label: t('application.minVersion'), placeholder: t('application.minVersionP'), component: 'el-input', type: 'text', model: null }
      // { prop: 'currentVersion', label: t('application.currentVersion'), placeholder: t('application.currentVersionP'), component: 'el-input', type: 'text', model: null },
      // { prop: 'packageAddress', label: t('application.packageAddress'), placeholder: t('application.packageAddressP'), component: 'el-input', type: 'text', model: null }
    ]

    const applicationRole = {
      appName: [{ required: true, message: t('application.appName').concat(t('common.isRequired')), trigger: 'blur' }],
      appDescription: [{ required: true, message: t('application.appDescription').concat(t('common.isRequired')), trigger: 'blur' }],
      // partnerNumber: [{ required: true, message: t('application.partnerNumber').concat(t('common.isRequired')), trigger: 'blur' }],
      minVersion: [{ required: true, message: t('application.minVersion').concat(t('common.isRequired')), trigger: 'blur' }]
      // currentVersion: [{ required: true, message: t('application.currentVersion').concat(t('common.isRequired')), trigger: 'blur' }],
      // packageAddress: [{ required: true, message: t('application.packageAddress').concat(t('common.isRequired')), trigger: 'blur' }]
    }

    const tableStruct = [

      { prop: 'appName', label: t('application.appName'), sortable: 'custom' },
      { prop: 'appDescription', label: t('application.appDescription'), sortable: 'custom' },
      { prop: 'partnerNumber', label: t('application.partnerNumber'), sortable: 'custom' },
      { prop: 'minVersion', label: t('application.minVersion'), sortable: 'custom' },
      { prop: 'currentVersion', label: t('application.currentVersion'), sortable: 'custom' },
      { prop: 'packageAddress', label: t('application.packageAddress'), sortable: 'custom' },
      { prop: 'createTime', label: t('common.createTime'), formatter: (row: ApplicationModel) => { return parseTime(row.createTime) }, sortable: 'custom' },
      { prop: 'updateTime', label: t('common.updateTime'), formatter: (row: ApplicationModel) => { return parseTime(row.updateTime) }, sortable: 'custom' }
    ]
    const dataMap = reactive({
      searchFormStruct: searchStruct,
      searchFormModel: createModel(searchStruct) as ApplicationSearchModel,
      tableData: Array<ApplicationModel>(),
      columnStruct: tableStruct,
      listLoading: true,
      selection: Array<number>(),
      limit: 10,
      total: 0,
      page: 1,
      sort: 'createTime',
      order: 'desc',
      dialogStatus: 'create',
      textMap: {
        update: 'application.edit',
        create: 'application.create'
      },
      dialogFormVisible: false,
      applicationRole: applicationRole,
      createStruct: createStruct,
      createModel: createModel(createStruct) as ApplicationAddModel,
      updateStruct: updateStruct,
      updateModel: createModel(updateStruct) as ApplicationUpdateModel,
      uploadPackageModel: {} as any,
      packageAddress: '',
      editRow: {} as ApplicationModel,
      loadingUpload: null as any,
      handleSelection(item: any[]) {
        dataMap.selection = item
      },
      handleCurrentChange(page?: any) {
        dataMap.page = page
        dataMap.getList()
      },
      handleSizeChange(val: any) {
        dataMap.limit = val
        dataMap.getList()
      },
      handleOrder(column: any) {
        dataMap.sort = column.prop
        dataMap.order = column.order === 'descending' ? 'desc' : 'asc'
        dataMap.getList()
      },
      async getList() {
        dataMap.listLoading = true
        const params: ApplicationPageSearchModel = {
          appName: dataMap.searchFormModel.appName,
          appDescription: dataMap.searchFormModel.appDescription,
          partnerNumber: dataMap.searchFormModel.partnerNumber,
          minVersion: dataMap.searchFormModel.minVersion,
          currentVersion: dataMap.searchFormModel.currentVersion,
          packageAddress: dataMap.searchFormModel.packageAddress,
          page: dataMap.page,
          limit: dataMap.limit,
          sort: dataMap.sort,
          order: dataMap.order
        }
        const data = await pageSearchApplication(params)
        dataMap.tableData = data?.data?.records ?? []
        const total = data?.data?.total ?? '0'
        dataMap.total = parseInt(total)

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      submitSearch() {
        dataMap.page = 1
        dataMap.getList()
      },
      resetForm() {
        console.log('reset')
      },
      async createSubmit() {
        const createData: ApplicationAddModel = {
          appName: dataMap.createModel.appName,
          appDescription: dataMap.createModel.appDescription,
          minVersion: dataMap.createModel.minVersion
        }
        const result = await addApplication(createData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          /* ElMessage({
            message: t('common.createSuccess'),
            type: 'success',
            duration: 2000
          }) */
          ElMessageBox.confirm(t('application.createTip'), t('message.tip'), {
            confirmButtonText: t('message.confirm'),
            cancelButtonText: t('message.cancel'),
            type: 'warning'
          }).then(() => {
            router.push({ path: '/product/applicationVersion/index' })
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async updateNameSubmit() {
        const updateData: ApplicationUpdateModel = {
          id: dataMap.updateModel.id,
          appName: dataMap.updateModel.appName,
          appDescription: dataMap.updateModel.appDescription,
          minVersion: dataMap.updateModel.minVersion
        }
        const result = await updateApplication(updateData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          if (updateUpload.value.validateUpload(true)) {
            ElMessage({
              message: t('common.createSuccess'),
              type: 'success',
              duration: 2000
            })
            return
          }
          dataMap.loadingUpload = ElLoading.service({
            lock: true,
            text: t('common.uploading'),
            background: 'rgba(0, 0, 0, 0.7)'
          })
          await updateUpload.value.submitUpload()
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
        // await updateUpload.value.submitUpload()
        /* if (result?.code === 0) {
          ElMessage({
            message: t('common.updateSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        } */
      },
      async deleteData(id: number) {
        const result = await removeApplication(id)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async bathDeleteData() {
        const deleteData: IdsModel = { ids: dataMap.selection }
        const result = await batchRemoveApplication(deleteData)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      updateNameReset() {
        console.log('update reset')
        dataMap.updateModel.id = dataMap.editRow.id
        dataMap.updateModel.appName = dataMap.editRow.appName
        dataMap.updateModel.appDescription = dataMap.editRow.appDescription
        dataMap.updateModel.minVersion = dataMap.editRow.minVersion
        dataMap.uploadPackageModel.id = dataMap.editRow.id
        dataMap.uploadPackageModel.version = dataMap.editRow.currentVersion
        // dataMap.packageAddress = dataMap.editRow.packageAddress?.substr(dataMap.editRow.packageAddress.lastIndexOf('/') + 1) ?? null
        if (updateUpload.value) {
          updateUpload.value.onReset()
        }
      },
      createReset() {
        console.log('create reset')
      }
    })
    const handleCreate = () => {
      dataMap.dialogStatus = 'create'
      dataMap.dialogFormVisible = true
    }
    const handleEdit = (row?: ApplicationModel) => {
      if (row) {
        dataMap.editRow = row
        dataMap.dialogStatus = 'update'
        dataMap.updateModel.id = row.id
        dataMap.updateModel.appName = row.appName
        dataMap.updateModel.appDescription = row.appDescription
        dataMap.updateModel.minVersion = row.minVersion
        dataMap.uploadPackageModel.id = row.id
        dataMap.uploadPackageModel.version = row.currentVersion
        // dataMap.packageAddress = row.packageAddress?.substr(row.packageAddress.lastIndexOf('/') + 1) ?? null
        if (updateUpload.value) {
          updateUpload.value.onReset()
        }
        dataMap.dialogFormVisible = true
      }
    }
    const handleDelete = (id: number) => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.deleteData(id)
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    const handleBathDelete = () => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.bathDeleteData()
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    const handleUpload = (result: any) => {
      console.log(result)
      if (dataMap.loadingUpload) {
        dataMap.loadingUpload.close()
      }
      if (result?.code === 0) {
        ElMessage({
          message: t('common.updateSuccess'),
          type: 'success',
          duration: 2000
        })
      } else {
        ElMessage({
          message: result?.message,
          type: 'error',
          duration: 2000
        })
      }
      dataMap.getList()
    }
    const getUploadUri = () => {
      return networkConfig.host + Route.product + '/application/update/package'
    }
    const getUploadHeader = () => {
      return {
        Authorization: 'Bearer ' + useStore().state.user.token
      }
    }
    onMounted(() => {
      dataMap.getList()
    })
    return {
      t,
      handleCreate,
      handleEdit,
      handleDelete,
      handleBathDelete,
      searchFormRef,
      getUploadUri,
      getUploadHeader,
      handleUpload,
      updateUpload,
      ...toRefs(dataMap)
    }
  }
})
</script>
